/** Extraction helper split out of PublishDialog.tsx so that file only
 * exports components (react-refresh/only-export-components). */
import { ApiError } from '@/services/apiClient'
import type { ConfigFinding } from '@/types/workflowConfig'

export function extractPublishFindings(error: unknown): ConfigFinding[] | null {
  if (error instanceof ApiError && error.detail && typeof error.detail === 'object') {
    const d = error.detail as { detail?: unknown; errors?: unknown }
    if (d.detail === 'validation_failed' && Array.isArray(d.errors)) {
      return d.errors as ConfigFinding[]
    }
  }
  return null
}
